document.addEventListener('DOMContentLoaded', function() {
/* ===== تنظيف روابط المنتجات من معلمات البحث ===== */
if (window.location.pathname.includes('/products/')) {
  // التحقق مما إذا كان الرابط الحالي يحتوي على معلمات بحث
  if (window.location.search) {
    // إنشاء URLSearchParams للتعامل مع معلمات البحث
    var urlParams = new URLSearchParams(window.location.search);
    
    // التحقق من وجود ref=review
    var hasRefReview = urlParams.get('ref') === 'review';
    
    var cleanUrl;
    if (hasRefReview) {
      // الاحتفاظ فقط بـ ref=review
      cleanUrl = window.location.origin + window.location.pathname + '?ref=review';
    } else {
      // إنشاء الرابط النظيف (بدون معلمات البحث)
      cleanUrl = window.location.origin + window.location.pathname;
    }
    
    // استخدام history.replaceState لتغيير URL دون إعادة تحميل الصفحة
    history.replaceState({}, document.title, cleanUrl);
  }
}

  /* ===== فتح الكيبورد عند الضغط على زر البحث ===== */
  var searchLink = document.querySelector('a[href="/search"]');
  var searchInput = document.querySelector('header-search .header-search__input');
  var searchDialog = document.querySelector('header-search[role="dialog"]');
  if (searchLink && searchInput && searchDialog) {
    searchLink.addEventListener('touchend', function(event) {
      event.preventDefault();
      if (!searchDialog.hasAttribute('open')) {
        searchDialog.setAttribute('open', '');
        searchDialog.style.display = 'block';
        // تجنب استدعاء offsetHeight للحد من إعادة التدفق
        setTimeout(function() {
          searchInput.focus();
        }, 10);
      } else {
        searchInput.focus();
      }
    });
  }

  /* ===== إخفاء زر "نفذ من المخزون" عندما يكون المنتج غير متوفر ===== */
  var soldOutButton = document.querySelector('.shopify-product-form .button[disabled]');
  if (soldOutButton) {
    soldOutButton.style.display = 'none';
  }

  /* ===== تخصيص التول بار لأجهزة الجوال ===== */
  var mobileNav = document.querySelector('.mobile-nav');
  var categoriesToggle = document.getElementById('categories-toggle');
  
  // تنفيذ دالة محسنة لفحص حجم الشاشة باستخدام throttle
  var resizeTimeout;
  function throttledCheckScreenSize() {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function() {
        checkScreenSize();
        resizeTimeout = null;
      }, 100);
    }
  }
  
  function checkScreenSize() {
    if (window.innerWidth <= 990) {
      if (mobileNav) {
        mobileNav.style.display = 'flex';
        document.body.style.paddingBottom = (mobileNav.offsetHeight + 10) + 'px';
      }
    } else {
      if (mobileNav) {
        mobileNav.style.display = 'none';
        document.body.style.paddingBottom = '0';
      }
    }
    
    // تحديث قوائم الفوتر عند تغيير حجم الشاشة
    updateFooterBlocks();
  }
  
  window.addEventListener('resize', throttledCheckScreenSize);
  checkScreenSize();
  
  if (categoriesToggle) {
    categoriesToggle.addEventListener('click', function(e) {
      e.preventDefault();
      var sidebarToggle = document.querySelector('[aria-controls="sidebar-menu"]');
      var headerCategoriesToggle = document.querySelector('[aria-controls="header-panel-1"]');
      if (sidebarToggle) {
        sidebarToggle.click();
        if (headerCategoriesToggle) {
          headerCategoriesToggle.click();
        }
      }
    });
  }

  /* ===== قوائم الفوتر القابلة للطي لأجهزة الجوال ===== */
  var footerBlocksProcessed = false;
  
  function updateFooterBlocks() {
    var isMobile = window.innerWidth <= 699;
    var footerBlocks = document.querySelectorAll('.footer__block');
    
    // تنفيذ التحويل فقط إذا كان الوضع مختلفًا عن الحالة السابقة
    if (isMobile && !footerBlocksProcessed) {
      footerBlocks.forEach(function(block) {
        var title = block.querySelector('.h6');
        if (title) {
          // تخزين المحتوى الأصلي لاستخدامه لاحقًا عند الحاجة
          if (!block.dataset.originalContent) {
            block.dataset.originalContent = block.innerHTML;
          }
          
          var content = title.nextElementSibling;
          var accordionDisclosure = document.createElement('accordion-disclosure');
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.innerHTML = title.textContent + '<span class="animated-plus"></span>';
          details.appendChild(summary);
          if (content) {
            details.appendChild(content.cloneNode(true));
          }
          accordionDisclosure.appendChild(details);
          
          // استخدام replaceChildren بدلاً من innerHTML للأداء الأفضل
          while (block.firstChild) {
            block.removeChild(block.firstChild);
          }
          block.appendChild(accordionDisclosure);
        }
      });
      footerBlocksProcessed = true;
    } else if (!isMobile && footerBlocksProcessed) {
      // إعادة المحتوى الأصلي عند العودة إلى وضع سطح المكتب
      footerBlocks.forEach(function(block) {
        if (block.dataset.originalContent) {
          block.innerHTML = block.dataset.originalContent;
        }
      });
      footerBlocksProcessed = false;
    }
  }
});